import { IconProps } from "./icon.type";

export function IcFlagVi({ ...props }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1858_37838)">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#D80027"
        />
        <path
          d="M8.00002 4.17383L8.8634 6.83098H11.6573L9.39696 8.47317L10.2603 11.1304L8.00002 9.48814L5.73971 11.1304L6.60309 8.47317L4.34277 6.83098H7.13665L8.00002 4.17383Z"
          fill="#FFDA44"
        />
      </g>
      <defs>
        <clipPath id="clip0_1858_37838">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
